export const ensureArray = <T>(value: null | undefined | T | T[]): T[] =>
    value == null ? [] : Array.isArray(value) ? value : [value];
